import {TweenMax} from 'gsap';
import detectMobile from '@/scripts/utils/detect-mobile';

export default function () {
  const containers = $('[data-type="parallax-container"]');

  if (!containers.length || detectMobile()) return;

  const GAP = 15;
  const current = {
    item: null,
    x: 0,
    y: 0,
  };
  const mouse = {
    x: 0,
    y: 0,
  };
  let raf = null;

  function animate() {
    // smooth cursor
    if (current.item) {
      const layer1 = $(current.item).find('[data-type="layer-1"]');
      const layer2 = $(current.item).find('[data-type="layer-2"]');
      const layer3 = $(current.item).find('[data-type="layer-3"]');
      const width = layer1.width();
      const height = layer1.height();
      const mouseX = mouse.x - (width / 2);
      const mouseY = mouse.y - (height / 2);

      current.x = (mouseX * GAP) / width;
      current.y = (mouseY * GAP) / height;
      TweenMax.to(layer1, 0.5, {
        x: current.x, y: current.y, z: 0, force3D: true, overwrite: 5,
      });
      TweenMax.to(layer2, 0.1, {
        rotationX: -current.y / 2.5,
        rotationY: +current.x / 2.5,
        rotateZ: 0,
        z: 30,
        force3D: true,
        overwrite: 5,
      });
      TweenMax.to(layer3, 0.1, {
        x: current.x,
        y: current.y,
        z: 45,
        force3D: true,
        overwrite: 5,
      });
    }
    raf = requestAnimationFrame(animate);
  }

  $(document).on('mouseenter', '[data-type="parallax-container"]', () => {
    raf = requestAnimationFrame(animate);
  });
  $(document).on('mousemove', '[data-type="parallax-container"]', function (e) {
    current.item = this;
    mouse.x = e.pageX - $(this).offset().left;
    mouse.y = e.pageY - $(this).offset().top;
  });
  $(document).on('mouseleave', '[data-type="parallax-container"]', function () {
    const layer1 = $(this).find('[data-type="layer-1"]');
    const layer2 = $(this).find('[data-type="layer-2"]');
    const layer3 = $(this).find('[data-type="layer-3"]');

    TweenMax.to(layer1, 0.5, { x: 0, y: 0, clearProps: 'all' });
    TweenMax.to(layer2, 0.5, { rotationX: 0, rotationY: 0, clearProps: 'all' });
    TweenMax.to(layer3, 0.5, { x: 0, y: 0, clearProps: 'all' });

    cancelAnimationFrame(raf);
    current.item = null;
    current.x = 0;
    current.y = 0;
  });
}




// WEBPACK FOOTER //
// ./scripts/elements/hover-parallax.js